import React, { useState } from "react";
import { useNavigate, Navigate } from "react-router-dom";
import { useAuth } from "@/contexts/AuthContext";
import { toast } from "sonner";

export default function Login() {
  const { user, login } = useAuth();
  const nav = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [busy, setBusy] = useState(false);

  if (user) return <Navigate to="/relationships" replace />;

  const onSubmit = async (e) => {
    e.preventDefault();
    setBusy(true);
    try {
      await login(email.trim().toLowerCase(), password);
      nav("/relationships");
    } catch (err) {
      toast.error(err.response?.data?.detail || "Login failed");
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="min-h-screen w-full flex items-center justify-center relative overflow-hidden bg-slate-50">
      <div
        aria-hidden
        className="absolute inset-0 bg-cover bg-center opacity-40"
        style={{
          backgroundImage:
            "url('https://images.pexels.com/photos/3062948/pexels-photo-3062948.jpeg')",
        }}
      />
      <div aria-hidden className="absolute inset-0 bg-gradient-to-br from-white/70 via-white/40 to-white/80" />

      <div className="relative w-full max-w-md mx-6 mr-fade-up">
        <div className="bg-white/85 backdrop-blur-2xl border border-white rounded-[2rem] shadow-[0_8px_40px_-12px_rgba(15,23,42,0.15)] p-10">
          <div className="text-center mb-8">
            <h1 className="font-logo text-4xl text-slate-900" data-testid="brand-logo">
              Michael Rist
            </h1>
            <div className="mt-2 text-xs uppercase tracking-[0.22em] text-slate-400 font-heading">
              Lender · CRM
            </div>
          </div>

          <form onSubmit={onSubmit} className="space-y-4" data-testid="login-form">
            <div>
              <label className="text-xs uppercase tracking-[0.1em] font-semibold text-slate-500">
                Email
              </label>
              <input
                type="email"
                required
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                className="mr-input mt-1.5"
                placeholder="you@example.com"
                data-testid="login-email-input"
              />
            </div>
            <div>
              <label className="text-xs uppercase tracking-[0.1em] font-semibold text-slate-500">
                Password
              </label>
              <input
                type="password"
                required
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                className="mr-input mt-1.5"
                placeholder="••••••••"
                data-testid="login-password-input"
              />
            </div>

            <button
              type="submit"
              disabled={busy}
              className="w-full mt-2 bg-slate-900 text-white rounded-lg py-2.5 text-sm font-medium font-heading hover:bg-slate-800 transition-colors active:scale-[0.99] disabled:opacity-60"
              data-testid="login-submit-button"
            >
              {busy ? "Signing in…" : "Sign in"}
            </button>
          </form>

          <div className="mt-6 text-center text-xs text-slate-400 font-body">
            Internal use only · Single-admin access
          </div>
        </div>
      </div>
    </div>
  );
}
